import { useFormik } from "formik";
import React, { ForwardRefRenderFunction, forwardRef, useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { Input } from "sr/helpers";
import * as Yup from "yup";
import { getUserDetails } from "sr/helpers/functions/getUserDetails";
import { changeContact } from "sr/utils/api/corporate/changeContact";

interface EmailChangeProps {
  HandleModel?: (open: boolean) => void;
  onOtpSent?: (channel: "Email" | "PhoneNo") => void;
}

const EmailChange: ForwardRefRenderFunction<any, EmailChangeProps> = (
  { onOtpSent,HandleModel },
  ref
) => {
  const intl = useIntl();
  const [corporateId, setCorporateId] = useState<string>("");

  useEffect(() => {
    const details = getUserDetails();
    if (details?.user_id) setCorporateId(details.user_id);
  }, []);

  const EmailChangeSchema = Yup.object({
    email: Yup.string()
      .email("INPUT.VALIDATION.EMAIL.INVALID")
      .required("INPUT.VALIDATION.EMAIL"),
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: { email: "" },
    validationSchema: EmailChangeSchema,
    onSubmit: async (values, { setErrors, setSubmitting }) => {
      try {
        const res = await changeContact({ corporateId, email: values.email });
        if (res?.success === true && res?.message === "OTP.SENT") {
          onOtpSent?.("Email");
          HandleModel?.(false);
        } else {
          setErrors({ email: res?.message || "Something went wrong" });
        }
      } finally {
        setSubmitting(false);
      }
    },
  });

  React.useImperativeHandle(ref, () => ({
    submitForm: formik.submitForm,
  }));

  return (
    <>
      <Input
        name="email"
        value={formik.values.email}
        onChange={formik.handleChange}
        error={formik.errors.email}
        InputDivClass="mt-0"
        inputClass="border border-zinc-800 rounded-lg h-11"
        label={intl.formatMessage({
          id: "RECRUITER.ACCOUNT.SETTINGS.CHANGE_EMAIL.INPUT.NEWMAIL",
          defaultMessage: "New email address",
        })}
      />
      {formik.isSubmitting && <p className="text-blue-600 text-sm mt-2">Sending OTP...</p>}
    </>
  );
};

export default forwardRef(EmailChange);
